// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".themes label input:checked+img{box-shadow:0 0 0 5px #6cc;border-radius:1px}", ""]);
// Exports
module.exports = exports;
